import { Box } from "@chakra-ui/react";
import { BidStatus, type BidDto } from "../../../../autogen/bff-api";
import { PreviousSigningBreadcrumb } from "./PreviousSigningBreadcrumb";
import { SigningPill } from "./SigningPill";

export const BidSigningHeaderBadge = ({ bid }: { bid: BidDto }) => {
  if (bid.signedDocumentId != null && bid.status === BidStatus.Draft) {
    return (
      <Box mt="2">
        <SigningPill />
      </Box>
    );
  }
  if (bid.signedDocumentId == null && bid.previousSigningOutcome) {
    return <PreviousSigningBreadcrumb outcome={bid.previousSigningOutcome} />;
  }
  return null;
};
